// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthorizedContainer_container__-SWYe"};